import ReturnTutorialCwalk from '../../../components/ReturnTutorialCwalkWithoutQR';

export default function ReturnTutorial() {
    return (
      <div>
        <ReturnTutorialCwalk />
      </div>
    )
  }